import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
  },
  info: {
    padding: 16,
    borderRadius: theme.borderRadius.xlg,
    border: `1px solid ${theme.palette.custom.border.primary}`,
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '4px',
  },
  row: {
    ...dFlex('space-between', 'center'),
    width: '100%',
  },
  inputContainer: {
    ...dFlex('unset', 'flex-start'),
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  balance: {
    padding: '0 16px',
  },
  totalInfo: {
    padding: '0 16px',
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '4px',
  },
}));

export default useStyles;
